import * as React from 'react';
import { useCallback, useRef } from 'react';

import { useToggleable } from '../../../hooks';
import { scrollTo } from '../../../utils';

export const useConsentsCheckbox = ({ needConfirm = false }: { needConfirm?: boolean } = {}) => {
	const checkboxRef = useRef<HTMLInputElement>(null);

	const { isOpen: isChecked, setOpen: setChecked } = useToggleable(false);
	const { isOpen: isOpenTooltip, open: onOpenTooltip, close: onCloseTooltip } = useToggleable(false);

	const isTooltipOpen = isOpenTooltip && !isChecked;
	const isNeedConfirm = !isChecked && needConfirm;

	const onChange = useCallback((_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => setChecked(checked), [
		setChecked
	]);

	const onConfirm = useCallback(() => {
		if (!isNeedConfirm) {
			return;
		}

		if (typeof checkboxRef.current?.offsetTop === 'number') {
			scrollTo(checkboxRef.current.offsetTop);
		}

		onOpenTooltip();
	}, [isNeedConfirm, checkboxRef, onOpenTooltip]);

	return {
		// data
		checkboxRef,
		isChecked,
		isTooltipOpen,
		isNeedConfirm,

		// methods
		setChecked,
		onOpenTooltip,
		onCloseTooltip,
		onChange,
		onConfirm
	};
};
